export default {
  LANGUAGE: {
    NORWEGIAN: 'Norsk',
    ENGLISH: 'Engelsk',
  },
  BACK: 'Tilbake',
  BACK_TO: 'Tilbake til {genreName}',
  CHECK: 'Kontrollér',
  EDIT: 'Rediger',
  GENRE: '{genre}',
  GENRE_WRITE: 'Skriv {genre}',
  GENRE_CHECK: 'Kontrollér {genre}',
  GENRE_SHARE: 'Del {genre}',
  EDITOR: {
    TOOLBAR: {
      BOLD: 'Fet',
      ITALIC: 'Kursiv',
      LIST: 'Punktliste',
      MEDIA: 'Sett inn bilde',
      NORMAL: 'Normal',
      SPEECH_TO_TEXT: 'Les inn tekst',
      TABLE: 'Sett inn tabell',
    },
    TABLE: {
      COLUMNS: {
        LABEL: 'Kolonner',
        ADD: {
          BEFORE: 'Sett inn kolonne til venstre',
          AFTER: 'Sett inn kolonne til høyre',
        },
        REMOVE: 'Fjern kolonne',
      },
      ROWS: {
        LABEL: 'Rader',
        ADD: {
          BEFORE: 'Sett inn rad over',
          AFTER: 'Sett inn rad under',
        },
        REMOVE: 'Fjern rad',
      },
      REMOVE: 'Fjern tabell',
    },
  },
  COLLAPSIBLE: {
    CLOSE: 'Lukk',
  },
  CHECKLIST: {
    TITLE: 'Sjekkliste',
  },
  DISPOSITION: {
    TITLE: 'Verktøy',
    ALT_IMAGE: 'Disposisjon struktur',
    TOOLS: 'Hjelp',
    FILM: 'Film - Hvordan skrive {genre}',
    EXAMPLE: 'Eksempel på {genre}',
    AUDIO: 'Lyd - {name}',
  },
  ERROR: {
    NO_ACCESS_TITLE: 'Du har ikke tilgang til dette produktet',
    NO_ACCESS_MESSAGE: 'Kontakt din lærer eller administrator for mer informasjon og hjelp.',
  },
  EXAMPLES: {
    TITLE: 'Eksempel på {genre} | Eksempler på {genre}',
    LINK_NAME: 'eksempel',
  },
  HEADER: {
    TITLE: 'Språk og innlogging',
    MAIN_LANGUAGE: 'Hovedspråk',
    MAIN_LANGUAGE_SUBTEXT: 'Endrer språk i navigasjon og innhold',
    PORTAL: 'Portal',
    DROPDOWN_TOGGLE: 'Topptekst nedtrekksmeny',
    LANG_NB: 'Bokmål',
    LANG_NB_SHORT: 'Bokm.',
    LANG_NN: 'Nynorsk',
    LANG_NN_SHORT: 'Nyno.',
    CLOSE: 'Lukk',
  },

  FOOTER: {
    PRIVACY: 'Personvern',
    CONTACT: 'Kontakt oss',
    COOKIE: 'Informasjonskapsler',
  },
  PAGINATION: {
    NEXT: 'Neste',
    PREV: 'Forrige',
  },
  HOME: 'Forside',
  LOADER: {
    TITLE: 'Laster',
  },
  SHARE_PAGE: {
    TITLE: 'DEL DOKUMENT',
    DOWNLOAD: {
      PDF: 'Last ned som PDF',
      WORD: 'Last ned som Word',
    },
  },
  ARCHIVE: {
    ZIP_NAME: 'Komprimert mappe',
    PDF_NAME: 'Pdf dokument',
    WORD_NAME: 'Word dokument',
    ATTACHMENT_DIR_NAME: 'Vedlegg',
  },
  LOGIN: 'Logg inn',
  LOGOUT: 'Logg ut',
  TASK: 'Oppgave',
  TASKS: {
    TITLE: 'Oppgave | Oppgaver',
    LINK_NAME: 'Oppgaver',
  },
  SHARE: 'Del',
  VIEW_ALL: 'Se alle',
  WRITE: 'Skriv',
  WRITE_STORY: {
    TITLE: 'Skriv {genre}',
    START_NEW: 'Lag en ny',
    CONTINUE: 'Fortsett på lagret',
  },
  WRITE_PAGE: {
    TIPS: 'Tips',
  },
  EXERCISE: {
    DEFAULT_NAME: 'Dokument uten navn',
    ATTACHMENT_COUNT: 'Vedlegg:',
  },
  SPEECH_TO_TEXT: {
    HEADER: {
      READ_IN: 'Les inn: ',
    },
    START_RECORDING: 'Start opptak nå',
    PAUSE_RECORDING: 'Pause',
    LABEL: 'Teksten din:',
    TRANSLATED_LABEL: 'Klargjør teksten: ',
    RESET_RECORDING: 'Tilbakestill (start på nytt)',
    CONTINUE_RECORDING: 'Fortsett på opptak',
    ERRORS: {
      DEVICE_NOT_FOUND: 'Finner ikke mikrofon. Vennligst sjekk systeminnstillingene',
      PERMISSION_DENIED: 'Ikke tillatelse til å bruke mikrofon. Vennligst sjekk nettleserinnstillingene',
      UNEXPECTED: 'Det oppstod en uventet feil. Prøv igjen senere',
    },
  },
  TEXT_TO_SPEECH: {
    LISTEN: 'Lytt til teksten',
    ERROR_NOT_ALLOWED: 'Lyden er klar. Spill av for å lytte til teksten.',
    SPEED_LABEL: 'Hastighet',
    SPEED: {
      SLOWLY: 'Sakte',
      QUICKLY: 'Raskt',
    },
  },
  VIDEO: {
    READ_TRANSCRIPTION: 'Les teksten',
    CHAPTERS: 'Gå til',
  },
  VIEW: {
    HOME: {
      DESCRIPTION:
        'De fleste yrker krever dokumentasjon av arbeid som grunnlag for kvalitetssikring og læring. Dette verktøyet viser hvordan du gjør det! Du kan skrive eller lese inn teksten din.',
      GENRES_LABEL: 'Velg sjanger',
      TITLE: 'VELKOMMEN!',
    },
  },
  ATTACHMENTS: {
    TITLE: 'Vedlegg (Valgfritt)',
    TEXT: 'Legg ved opp til {maxFiles} filer',
    REMOVE: 'Fjern',
  },
  MODAL: {
    OVERWRITE_DOCUMENT: {
      TITLE: 'Informasjon',
      TEXT: 'Du vil nå starte et nytt dokument. Tidligere lagret tekst blir skrevet over',
    },
    UPLOAD: {
      IMAGE: {
        TITLE: 'Last opp bilde',
        TEXT: 'Kun en fil per opplastning. (Støttede formater er: jpeg og png)',
        BUTTON_UPLOAD: 'Last opp bilde',
      },
      ATTACHMENT: {
        TITLE: 'Last opp vedlegg',
        TEXT: 'Legg ved opptil 10 filer (Maks størrelse er 5MB per fil)',
        BUTTON_UPLOAD: 'Last opp en eller flere filer',
      },
      PROGRESS: 'Laster opp, {progress}% fullført',
      FILE_ERROR: 'Filen er over 5MB!',
      FILE_REMOVE: 'Fjern',
      SIZE_ERROR: 'Du må fjerne alle filer over 5MB for å kunne lagre.',
      PORTRAIT_WARN_TITLE: 'OBS!',
      PORTRAIT_WARN_TEXT:
        'Verktøyet roterer ikke bilder i stående format fra Mac og iPhone. - Anbefaler å velge bilder i liggende format for å unngå problemet.',
      CANCEL: 'Avbryt',
      SAVE: 'Sett inn',
    },
    ERROR: {
      TITLE: 'Feil oppsto',
      TEXT: 'Det oppstod en uventet feil. Prøv igjen senere',
    },
    PRINT_BUTTON: 'Skriv ut',
    EXAMPLE_DETAILS: {
      DISPOSITION: 'Disposisjon',
      DESCRIPTION: 'Klikk for å fremheve i eksemplet',
      HIGHLIGHT: 'Vis i eksempel',
    },
    LOGOUT: {
      TITLE: 'Informasjon',
      TEXT: 'Du vil logge ut av alle dine produkter hos Fagbokforlaget',
    },
  },
  BUTTON: {
    CANCEL: 'Avbryt',
    INSERT: 'Sett inn',
    START_WRITING: 'OK, start å skrive',
  },
  DOCUMENT_CONTROL: {
    MANAGE: 'Valg',
    SAVE_AS: 'Lagre som',
    SAVE: 'Lagre',
    RENAME: 'Endre navn',
    DELETE: 'Slett dokumentet',
    CLOSE: 'Lukk',
  },
  ARIA: {
    CLOSE_MODAL: 'lukk vindu',
    UPLOAD: 'Last opp fil',
    REMOVE_FILE: 'Fjern fil',
    SAVE: 'Lagre',
    CANCEL: 'Avbryt',
    OK: 'OK',
  },
  IMAGE_FIELD: {
    LABEL_NEW: 'Sett in bilde',
    LABEL_UPDATE: 'Endre bilde',
  },

  RENAME_MODAL: {
    TITLE: 'Endre navn:',
    OK: 'Utfør',
    CLOSE: 'Avbryt',
  },

  REMOVE_MODAL: {
    TITLE: 'Slett dokument',
    MESSAGE: 'Er du sikker?',
    DELETE: 'Slett',
    ABORT: 'Avbryt',
  },

  SAVE_AS_MODAL: {
    TITLE: 'Lagre som:',
    OK: 'OK',
    CLOSE: 'Lukk',
  },

  DOCUMENT_MODAL: {
    TITLE: 'Mine dokumenter',
    DESCRIPTION: 'Her finner du dine lagrede dokumenter for alle sjangere.',
    EDIT_BTN: 'Rediger',
    SAVE_BTN: 'Ferdig',
    FILTER_ALL: 'ALLE',
    EMPTY: 'Ingen dokumenter',
    UNDO_DELETE: 'Angre slett',
  },
  AUTO_SYNC: {
    TITLE: {
      SUCCESS: 'Lagres automatisk',
      ERROR: 'Ingen nettforbindelse',
      DEFAULT: 'Lagrer',
    },
    SUBTITLE: {
      SUCCESS: '',
      ERROR: 'Lagres når nettet er tilbake',
      DEFAULT: '',
    },
  },

  ALIGN: {
    RIGHT: 'Flytt mot høyre',
    LEFT: 'Flytt mot venstre',
    CENTER: 'Midtstill',
  },

  ADJUST_IMAGE: {
    LABEL: 'Tilpass',
    WIDTH_100: '100 % bredde',
    WIDTH_50: '50 % bredde',
  },

  SEE_ALL: {
    LINK: 'Vis alle',
    TASKS: 'Alle oppgaver',
    EXAMPLES: 'Alle Eksempler',
    TITLE: {
      TASKS: 'Oppgaver',
      EXAMPLES: 'Eksempler',
    },
  },
  ALERT: {
    OFFLINE: {
      TITLE: 'Obs!',
      TEXT: 'Noen funksjoner virker ikke uten internettilkobling.',
      FEATURE_TEXT: 'Denne funksjonen virker ikke uten internettilkobling.',
    },
  },
  LOGO: {
    ALT: 'Illustrasjon av grå skiftenøkkel og grønn blyant',
  },
};
